import { useContext } from 'react';
import GlobalContext from './context';

const useGlobalContext = () => {
  const globalStore = useContext(GlobalContext);
  return globalStore;
};

export default useGlobalContext;
